<template>
  <div class="auth-links">
    <template v-if="username">
      <span class="auth-text">
        <span v-if="isMobile">欢迎</span>
        <span v-else>欢迎，{{ username }}</span>
      </span>
      <span class="divider">/</span>
      <a href="#" @click.prevent="logout" class="auth-link">退出</a>
    </template>
    <template v-else>
      <a href="/login" class="auth-link">
        <img src="@/assets/memberLogin.svg" alt="会员登录" class="auth-icon-inline" /> 会员登录
      </a>
    </template>

    <span class="divider">/</span>
    <a href="/register" class="auth-link">注册</a>
    <span class="divider">/</span>
    <a href="tel:13501251657" class="auth-link hotline-link">
      <img src="@/assets/consult.svg" alt="24小时热线" class="auth-icon-inline" /> 24小时热线：13501251657
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: localStorage.getItem('username') || '',
      // 使用 import 来导入图片
      memberLoginIcon: import('@/assets/memberLogin.svg'),
      consultIcon: import('@/assets/consult.svg'),
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 1200;
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      this.username = '';
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.auth-links {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: black;
  gap: 6px;
  transition: all 0.3s ease;
}

.auth-icon-inline {
  font-size: 14px;
  height: 20px;
  vertical-align: middle;
  margin-right: 4px;
  color: black;
}

.auth-link {
  color: black;
  text-decoration: none;
  transition: color 0.2s;
  font-size: 13px;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.auth-link:hover {
  color: #c9221d;
}

.hotline-link {
  font-weight: 600;
  color: #c9221d;
}

.divider {
  color: #ccc;
  user-select: none;
  font-weight: 400;
  font-size: 13px;
}
</style>
